// extracted by mini-css-extract-plugin
export default {"container":"logoInformationText_container__GKd+V","imgContainer":"logoInformationText_imgContainer__sFGY2","textContainer":"logoInformationText_textContainer__rlGe7"};